import type { Catalog } from "../../en";

/** Filipino: platform admin tenant-detail screen (mirrors en). */
export const tenantDetail: Catalog["adminScreens"]["tenantDetail"] = {
  notAvailable: "Hindi pa available",
  soon: "Malapit na",
  notFound: "Hindi nahanap ang tenant",
  notFoundBody: "Maaaring na-delete na ito, o mali ang link.",
  backToTenants: "Bumalik sa mga tenant",
  header: {
    since: "mula {{date}}",
    owner: "May-ari: {{owner}}",
    copyId: "Kopyahin ang tenant ID {{id}}",
    copyFailed: "Hindi makopya — piliin ang ID at kopyahin nang manu-mano",
    addCredits: "Magdagdag ng credits",
    applyDiscount: "Maglagay ng discount",
    emailReport: "I-email ang usage report",
    suspendedReason: "Naka-suspend: {{reason}}",
    pinned: "Mga naka-pin na tala",
  },
  tabs: {
    label: "Mga seksyon ng tenant",
    overview: "Buod",
    usage: "Paggamit",
    service: "Service Desk",
    billing: "Billing",
    members: "Mga miyembro",
    agents: "Agents at Kaalaman",
    limits: "Limits at Overrides",
    audit: "Audit",
    notes: "Mga tala",
    failures_one: "{{count}} pagkabigo sa ingestion",
    failures_other: "{{count}} pagkabigo sa ingestion",
  },
  service: {
    banner: "Hindi nakikita ng platform staff ang nilalaman ng ticket. Gumamit ng audited impersonation kung humihingi ng tulong ang tenant.",
    usageLabel: "Paggamit ng Service Desk, {{month}}",
    off: { title: "Hindi naka-on ang Service Desk para sa {{name}}", body: "Walang naka-on na Service Desk ang workspace, kaya walang paggamit na maipapakita.", planBody: "Hindi kasama sa plano ang help desk, kaya walang paggamit na maipapakita." },
    tickets: { title: "Mga ticket", info: "Mga ticket na nagawa ngayong buwan. Hindi hinaharangan ng patas na paggamit ang mga kliyente: ie-e-mail ang mga may-ari sa 80% at 100%.", of: "{{value}} patas na paggamit", unlimited: "walang limitasyon sa patas na paggamit", percent: "{{value}}% ng patas na paggamit", chart: "Mga ticket na nagawa kada araw, nakaraang {{count}} araw", table: "Ipakita bilang talahanayan", day: "Araw", count: "Mga ticket" },
    orders: { title: "Mga order", info: "Mga order na inilagay sa chat, web app o ng staff ngayong buwan. Mga bilang lang; walang halagang ipinapakita sa platform staff.", note: "Inilagay ngayong buwan. Walang halagang ipinapakita sa platform staff.", none: "Wala sa planong ito" },
    percentOfLimit: "{{value}}% ng limitasyon",
    catalogue: { title: "Mga item sa catalogue", info: "Mga aktibong produktong naka-cache mula sa purchasing system ng tenant, laban sa limitasyon ng plano.", of: "sa {{value}}" },
    staffAi: { title: "Mga staff AI credit", info: "Mga credit na ibinawas sa mga gawain ng staff AI ngayong buwan. Sumusunod ang chat ng kliyente sa karaniwang quota ng mensahe.", note: "Nagamit ngayong buwan sa mga buod, iminumungkahing sagot at triage." },
    assets: { title: "Kagamitan", info: "Kagamitang ginagamit pa (hindi na-decommission, ibinalik o na-archive). Bilang lang: walang pangalan o serial number.", of: "sa {{value}}" },
    fieldSeats: { title: "Mga field seat", info: "Mga miyembrong Field engineer lang ang tungkulin, laban sa mga field seat na ibinibigay ng plano at mga add-on.", of: "sa {{value}}" },
    storage: { title: "Storage ng attachment", info: "Mga larawan, dokumento at lagda na naka-attach sa mga ticket, hiwalay sa storage ng knowledge.", mb: "{{value}} MB", gb: "{{value}} GB", of: "sa {{value}}", unlimited: "walang limitasyon", percent: "{{value}}% ang nagamit" },
    connectors: { title: "Mga connector", info: "Mga connector na ginagamit laban sa limitasyon ng plano, kasama ang kalusugan ng huling {{window}} tawag.", none: "Wala pang naka-set up", of: "sa {{limit}}", calls: "{{ok}} ok, {{failed}} pumalya sa huling {{total}} tawag", noCalls: "Wala pang tawag", health: { none: "Walang connector", healthy: "Malusog", degraded: "Humina", unhealthy: "Hindi malusog" }, notice: "Mga bilang at status lang. Nananatili sa tenant ang detalye ng mga tawag at nilalaman ng order." },
    fairUse: { title: "Patas na paggamit", sub: "{{used}} ticket sa {{limit}} ngayong buwan. Hindi kailanman hinaharangan ang paggawa ng ticket ng mga kliyente.", subUnlimited: "{{used}} ticket ngayong buwan. Walang limitasyon sa patas na paggamit ang planong ito.", at80: "Ie-e-mail ang mga may-ari sa 80%", at100: "Ie-e-mail ang mga may-ari sa 100%", at120: "Aabisuhan ang CRUD.IT sales pagkatapos ng 2 buwang higit sa 120%", tickets: "{{value}} ticket", state: { below: "Mas mababa sa 80%", above80: "Higit sa 80%", at100: "Nasa 100%", above120: "Higit sa 120%" } },
    support: { title: "Access ng support", body: "Kung humingi ng tulong ang tenant tungkol sa ticket, order o connector, magsimula ng audited impersonation session. Read-only ito: bawat pahinang bubuksan mo, kasama ang nilalaman ng ticket, ay isusulat sa audit log ng tenant kasama ang iyong dahilan.", button: "Humiling ng audited impersonation", readOnly: "Hindi makapagsisimula ng impersonation session ang tungkulin mo." },
    infoLabel: "Ano ang ibig sabihin ng {{title}}?",
    error: "Hindi namin mabasa ang mga counter ng paggamit. Subukan ulit maya-maya.",
  },
  overview: {
    kpis: "Mga KPI ng tenant",
    mrr: "MRR",
    plan: "{{plan}} plan",
    messages: "Mga mensahe ngayong buwan",
    ofLimit: "sa {{limit}} na kasama",
    members: "Mga miyembro",
    pendingInvites_one: "{{count}} nakabinbing imbitasyon",
    pendingInvites_other: "{{count}} nakabinbing imbitasyon",
    aiCost: "Gastos sa AI ngayong cycle",
    margin: "margin {{pct}}",
    usageVsPlan: "Paggamit kumpara sa {{plan}} plan",
    overridden_one: "{{count}} override",
    overridden_other: "{{count}} overrides",
    messagesLabel: "Mga mensahe",
    messagesHint: "Ngayong buwan, kasama ang overrides",
    agentsLabel: "Agents",
    atLimit: "Nasa limit · mag-alok ng dagdag na agent o upgrade ng plan",
    storageLabel: "Storage",
    sources_one: "{{count}} source",
    sources_other: "{{count}} sources",
    seatsLabel: "Seats",
    knowledge: "Kaalaman",
    liveAgents: "Mga live na agent",
    sourcesLabel: "Sources",
    chunks: "Chunks",
    failures: "Mga pagkabigo sa ingestion",
    none: "Wala",
    agents: "Agents",
    msgsCycle: "Mensahe ngayong cycle",
    noAgentUsage: "Wala pang trapiko ng agent sa panahong ito.",
    activity: "Kamakailang aktibidad",
    fullAudit: "Buong audit",
    noActivity: "Wala pang aktibidad",
    noActivityBody: "Lalabas dito ang mga event ng workspace habang nangyayari.",
  },
  usage: {
    range: "Saklaw ng paggamit",
    ranges: { "30d": "Huling 30 araw", "90d": "90 araw", cycle: "Ngayong cycle" },
    export: "I-export ang paggamit",
    stats: "Kabuuang paggamit",
    messages: "Mga mensahe",
    days_one: "{{count}} araw",
    days_other: "{{count}} araw",
    tokensIn: "Tokens in",
    tokensOut: "Tokens out",
    avgPerMsg: "avg {{value}} / mensahe",
    storage: "Storage",
    storageFoot: "Mga file at vector",
    rerank: "Rerank calls",
    embeddingTokens: "{{value}} embedding tokens",
    perDay: "Mga mensahe bawat araw",
    noMessages: "Walang mensahe sa panahong ito",
    noMessagesBody: "Lalabas dito ang trapiko kapag sumasagot na ang mga agent ng tenant.",
    margin: "Gastos sa AI kumpara sa kita",
    revenue: "Kita",
    aiCost: "LLM + embeddings + rerank",
    grossMargin: "Gross margin",
    fxNote: "Kinonvert sa {{fx}}/USD. Hindi kasama ang bahagi ng infra (hosting, storage).",
    byAgent: "Ayon sa agent",
    agent: "Agent",
    cost: "Gastos",
    share: "Bahagi ng mga mensahe",
  },
  billing: {
    refund: {
      actions: "Mga aksyon sa bayad",
      action: "I-refund",
      title: "I-refund ang bayad",
      body: "Hanggang {{amount}} ang maaaring i-refund sa {{gateway}}. Hindi na ito mababawi.",
      amount: "Halaga ({{currency}})",
      amountHint: "Iwanang blangko para i-refund ang lahat ng natitira.",
      amountInvalid: "Maglagay ng halagang hindi lalampas sa natitira.",
      reason: "Dahilan (itatala sa audit log)",
      confirm: "I-refund",
      done: "Na-refund · {{amount}} sa kabuuan",
      refunded: "{{amount}} na-refund",
    },
    subscription: "Subscription",
    plan: "Plan",
    price: "Presyo",
    pricePer: { monthly: "{{price}} / buwan", annual: "{{price}} / taon" },
    nextInvoice: "Susunod na invoice",
    email: "Billing email",
    status: "Status",
    subStatuses: { active: "Aktibo", trialing: "Nasa trial", past_due: "Lampas na sa takdang bayad", canceled: "Kinansela", cancelled: "Kinansela", incomplete: "Hindi kumpleto" },
    cycle: "Billing cycle",
    cycles: { monthly: "Buwanan", annual: "Taunan" },
    discount: "Discount",
    discountActive: "Aktibo",
    scheduled: "Nakatakdang pagbabago",
    scheduledYes: "Sa susunod na renewal",
    noSubscription: "Walang subscription",
    noSubscriptionBody: "Walang aktibong subscription ang workspace na ito. Pumili ng plan para magsimula ang billing.",
    applyDiscount: "Maglagay ng discount / credit",
    switchAnnual: "Lumipat sa taunan",
    invoices: "Mga invoice",
    orNote: "Ibinibigay ang BIR official receipt pagkabayad",
    invoice: "Invoice",
    period: "Panahon",
    amount: "Halaga",
    paidVia: "Binayaran sa",
    orNumber: "OR No.",
    invoiceStatuses: { paid: "Bayad", open: "Bukas", draft: "Draft", void: "Void", uncollectible: "Hindi makolekta", failed: "Nabigo" },
    noInvoices: "Wala pang invoice.",
    payments: "Mga pagtatangkang magbayad",
    date: "Petsa",
    method: "Paraan",
    outcome: "Resulta",
    paymentStatuses: { succeeded: "Tagumpay", paid: "Bayad", pending: "Nakabinbin", failed: "Nabigo", refunded: "Na-refund" },
    noPayments: "Wala pang pagtatangkang magbayad.",
    failedNotice_one: "{{count}} nabigong bayad",
    failedNotice_other: "{{count}} nabigong bayad",
    failedNoticeBody: "Tingnan ang mga pagtatangkang magbayad sa ibaba. Awtomatikong umuulit ang gateway.",
  },
  members: {
    title: "Mga miyembro ng team",
    seats: "{{used}} sa {{limit}} seats",
    seatsUnlimited: "{{used}} seats · walang limit",
    filter: "I-filter ang mga miyembro…",
    member: "Miyembro",
    role: "Tungkulin",
    twoFactor: "2FA",
    lastActive: "Huling aktibo",
    roles: { owner: "May-ari", admin: "Admin", editor: "Editor", viewer: "Viewer", agent: "Agent (Inbox)" },
    statuses: { invited: "Inimbitahan", disabled: "Naka-disable", suspended: "Naka-suspend" },
    enrolled: "Naka-enroll",
    notEnrolled: "Hindi naka-enroll",
    reset: "I-reset ang 2FA",
    resetFor: "I-reset ang 2FA ni {{member}}",
    remind: "Paalalahanan",
    noMatch: "Walang tugmang miyembro",
    noMatchBody: "Subukan ang ibang pangalan, email o tungkulin.",
    clear: "I-clear ang filter",
    empty: "Wala pang miyembro",
    emptyBody: "Imbitahan ang may-ari ng workspace mula sa tenant console.",
  },
  reset2fa: {
    title: "I-reset ang 2FA ni {{member}}?",
    description: "Aalisin ang kasalukuyang authenticator at kailangan niyang mag-enroll ulit sa susunod na pag-sign in. Gawin lang ito pagkatapos ma-verify ang pagkakakilanlan.",
    method: "Paraan ng pag-verify",
    methods: { callback: "Callback sa nakarehistrong landline", video_call: "Video call na may ID", owner_request: "Hiling mula sa may-ari ng tenant" },
    submit: "I-reset ang 2FA",
    done: "Na-reset ang 2FA ni {{member}} · naitala sa audit",
  },
  knowledge: {
    agents: "Agents",
    agentStatuses: { live: "Live", draft: "Draft", paused: "Naka-pause", archived: "Naka-archive" },
    publicKey: "Public key",
    failures: "Mga pagkabigo sa ingestion",
    retryAll: "Ulitin lahat",
    retry: "Ulitin",
    retryFor: "Ulitin ang {{source}}",
    retried_one: "{{count}} source ang naka-queue para i-ingest ulit",
    retried_other: "{{count}} source ang naka-queue para i-ingest ulit",
    noFailures: "Walang pagkabigo sa ingestion",
    noFailuresBody: "Malinis na na-parse at na-embed ang bawat source.",
    source: "Source",
    stage: "Yugto",
    stages: { upload: "Upload", parse: "Pag-parse", ocr: "Pag-parse (OCR)", chunk: "Pag-chunk", embed: "Pag-embed", index: "Pag-index" },
    error: "Error",
    attempts: "Mga pagtatangka",
    when: "Kailan",
    sources: "Mga knowledge source",
    summary_one: "{{count}} source · {{chunks}} chunks · {{mb}} MB",
    summary_other: "{{count}} sources · {{chunks}} chunks · {{mb}} MB",
    type: "Uri",
    types: { file: "File", website: "Website", text: "Teksto", qa: "Q&A" },
    pages_one: "{{count}} pahina",
    pages_other: "{{count}} pahina",
    chunks: "Chunks",
    status: "Status",
    statuses: { ready: "Handa", processing: "Pinoproseso", queued: "Naka-queue", pending: "Nakabinbin", failed: "Nabigo", error: "Error" },
    synced: "Huling na-sync",
    noSources: "Walang knowledge source",
    noSourcesBody: "Hindi pa nag-upload ng file o nagkonekta ng website ang tenant.",
  },
  graph: {
    title: "Knowledge graph",
    stage: "Experiment",
    info: "Mga entity at relation na nakuha mula sa mga aktibong knowledge chunk, ginagamit bilang dagdag na retrieval branch. Bilang at detalye ng run lang ang nakikita ng platform staff, hindi ang mga pangalan o teksto ng chunk.",
    status: { active: "Aktibo", off: "Naka-off" },
    blockedBy: {
      platform_flag: "Naka-off ang platform flag na graphrag_experiment para sa workspace na ito.",
      plan: "Hindi kasama sa plan ng workspace ang knowledge graph.",
      tenant_override: "Naka-off ang graph para sa workspace na ito.",
      agent: "Walang agent na naka-Assist, kaya walang kinukuha.",
    },
    layers: {
      label: "Mga control layer",
      on: "Naka-on",
      off: "Naka-off",
      flag: { name: "Platform flag", detail: "graphrag_experiment, global o rollout list" },
      plan: { name: "Feature ng plan", included: "Kasama", notIncluded: "Hindi kasama", detail: "graph_retrieval sa {{plan}} plan" },
      switch: { name: "Switch ng workspace", detail: "Nauuna sa plan para sa workspace na ito (Limits at Overrides)", inherit: "Sumusunod sa plan", on: "Naka-on", off: "Naka-off" },
      agents: { name: "Agents", value: "{{assist}} sa {{total}} ang naka-Assist", detail: "Mga agent na naka-Assist ang knowledge graph", none: "Wala pang agent ang workspace na ito" },
    },
    counts: { entities: "Entities", relations: "Relations" },
    empty: {
      title: "Wala pang graph",
      activeBody: "Pinapayagan ito ng bawat layer. Lalaki ang graph habang ina-index ang mga source; gamitin ang Buuin ulit ang graph para kumuha mula sa mga source na nandiyan na.",
      offBody: "May layer na naka-off, kaya walang kinukuha. I-on ang mga layer para makabuo ng graph.",
      openLimits: "Buksan ang Limits & Overrides",
      openFlags: "Buksan ang Feature flags",
    },
    lastRun: {
      title: "Huling extraction run",
      none: "Wala pang extraction run.",
      statuses: { queued: "Naka-queue", running: "Tumatakbo", succeeded: "Nagtagumpay", failed: "Nabigo", deferred: "Ipinagpaliban (lampas sa budget)", deferredSize: "Ipinagpaliban (masyadong malaki ang workspace)" },
      reasons: { graph_size_limit: "Mas marami ang aktibong chunk kaysa sa limit ng graph (25,000 maliban kung na-override): naghihintay ang extraction at rebuild hanggang matanggal ang mga source o tumaas ang limit. Sumasagot pa rin ang kasalukuyang graph." },
      when: "Kailan",
      chunks: "Mga chunk na naproseso",
      added: "Nadagdag",
      addedValue: "{{entities}} entities · {{relations}} relations",
      model: "Model",
      cost: "Gastos",
    },
    budget: {
      title: "Mga chunk ngayong buwan",
      value: "{{used}} / {{limit}}",
      percent: "{{value}}% ng alokasyon ng {{month}}",
      overridden: "limit na itinakda para sa workspace na ito",
      none: "Walang buwanang alokasyon sa planong ito. Itakda ang graph_monthly_chunks sa Limits at Overrides para payagan ang extraction.",
    },
    rebuild: {
      action: "Buuin ulit ang graph",
      title: "Buuin ulit ang knowledge graph?",
      body: "Kukunin ulit ang mga entity at relation ng {{tenant}}. Gumagamit ito ng model tokens at binibilang sa buwanang budget. Isang rebuild lang bawat workspace kada 5 minuto.",
      confirm: "Buuin ulit",
      queued: "Naka-queue ang rebuild para sa {{tenant}}",
    },
    errors: {
      disabled: "May control layer na naka-off sa workspace na ito, kaya hindi mabuo ulit ang graph.",
      notReady: "Wala pang extraction worker para sa graph sa deployment na ito.",
    },
  },
  limits: {
    infoBefore: "Para sa tenant na ito lang ang overrides at mas inuuna kaysa sa mga default ng ",
    planLink: "{{plan}} plan",
    infoAfter: ". Iwanang blangko ang field para sundin ang halaga ng plan. Naitatala sa audit log ang bawat pagbabago.",
    title: "Limits",
    fields: {
      message_credits: "Buwanang limit ng mensahe",
      max_file_mb: "Pinakamalaking file (MB)",
      rate_limit_rpm: "Rate limit (requests / minuto / widget)",
      storage_mb: "Storage (MB)",
      agents: "Agents",
      seats: "Seats",
      graph_monthly_chunks: "Budget ng knowledge graph (chunks / buwan)",
    },
    planDefault: "Default ng plan: {{value}}",
    placeholder: "{{value}} (plan)",
    invalid: "Maglagay ng buong numero, o iwanang blangko para sundin ang plan.",
    expires: "Pag-expire ng overrides",
    expiresHint: "Opsyonal. Babalik sa plan ang limits pagkatapos ng petsang ito.",
    allowedModels: "Mga pinapayagang model",
    premium: "{{provider}} · Pro+",
    planModels: "Mga default na model ng plan",
    modelsInherit: "Sinusunod ang mga model ng plan hangga't hindi mo binabago ang pinili.",
    modelsRestricted: "Limitado sa mga napiling model para sa tenant na ito.",
    save: "I-save ang overrides",
    saved: "Na-save ang overrides para sa {{tenant}}",
    resetDone: "Ibinalik sa default ng plan ang overrides",
  },
  flags: {
    title: "Feature flags",
    note: "Agad na nase-save at naitatala ang bawat switch.",
    on: "Naka-on ang {{flag}}",
    off: "Naka-off ang {{flag}}",
    voice: { name: "Voice (beta)", description: "Pagsasalita at pakikinig sa web app" },
    mobile_white_label: { name: "Mobile white-label", description: "Sariling pangalan at icon ng app sa mga store" },
    actions: { name: "Actions", description: "Booking, lead forms, webhooks" },
    custom_domains: { name: "Custom domains", description: "Ihain ang web app sa domain ng tenant" },
    byok: { name: "Sariling API key", description: "Sariling OpenAI/Anthropic key ng tenant" },
    remove_branding: { name: "Alisin ang “Powered by Sagot”", description: "Karaniwang bayad na add-on" },
    graph_retrieval: { name: "Knowledge graph (Experiment)", description: "Entity graph bilang dagdag na retrieval branch" },
  },
  audit: {
    search: "Maghanap ng event…",
    time: "Oras",
    actor: "Gumawa",
    event: "Event",
    target: "Target",
    ip: "IP",
    staff: "CRUD.IT · {{name}}",
    via: "sa pamamagitan ni {{name}}",
    actorTypes: { staff: "Staff ng CRUD.IT", tenant: "Miyembro", system: "System", end_user: "End user", api_key: "API key" },
    loadMore: "Mag-load pa",
    empty: "Wala pang audit event",
    emptyBody: "Dito naitatala ang mga pagbabago sa workspace na ito.",
    noMatch: "Walang tugmang event",
    noMatchBody: "Subukan ang ibang pangalan ng event, gumawa o target.",
    clear: "I-clear ang paghahanap",
  },
  notes: {
    title: "Mga internal na tala",
    visibility: "Makikita lang ng staff ng CRUD.IT",
    unknownAuthor: "Dating staff",
    categories: { account_management: "Account management", sales: "Sales", support: "Support", billing: "Billing", risk: "Panganib" },
    pinned: "Naka-pin",
    pin: "I-pin",
    unpin: "I-unpin",
    pinnedDone: "Naka-pin ang tala sa header ng tenant",
    unpinned: "Na-unpin ang tala",
    empty: "Wala pang tala",
    emptyBody: "Magdagdag ng konteksto para sa team — tawag, pangako, panganib — gamit ang form.",
    addTitle: "Magdagdag ng tala",
    category: "Kategorya",
    note: "Tala",
    placeholder: "hal. Tinawagan ang may-ari tungkol sa renewal, gusto ng taunang billing mula Enero…",
    required: "Isulat muna ang tala.",
    pinToHeader: "I-pin sa header ng tenant",
    add: "Idagdag ang tala",
    added: "Naidagdag ang tala",
  },
  trial: {
    action: "Pahabain ang trial",
    title: "Pahabain ang trial",
    descriptionTrial: "Nagdadagdag ng libreng araw sa trial at inuurong ang petsa ng unang invoice.",
    descriptionPaid: "Nasa bayad na plan ang tenant na ito. Nagbibigay ito ng libreng araw sa ibabaw ng kasalukuyang period at inuurong ang susunod na invoice.",
    days: "Dagdag na araw",
    reason: "Dahilan",
    reasonPlaceholder: "hal. Naantala ang onboarding dahil sa suspensyon dulot ng bagyo",
    reasonRequired: "Maglagay ng maikling dahilan (makikita sa audit log).",
    submit: "Pahabain",
    done: "Pinahaba ang trial nang {{days}} araw · matatapos na sa {{date}}",
  },
};
